import TagManager from '@sooro-io/react-gtm-module'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'
const ANALYTICS_COOKIES_ACCEPTED_VERSION = '1'
const ANALYTICS_COOKIE_NAME = 'analyticsCookiesAccepted'

const shouldUseGTM = () => {
    const gtmId = getEnvVariableValue(VARIABLES.GTM_ID)
    return (
        gtmId &&
        gtmId !== '' &&
        getCookie(ANALYTICS_COOKIE_NAME) === ANALYTICS_COOKIES_ACCEPTED_VERSION
    )
}

export const pushGtmDataLayer = data => {
    if (!shouldUseGTM()) {
        return
    }

    TagManager.dataLayer({
        dataLayer: data,
    })
}

export function getCookie(name) {
    const cookieValue = document.cookie
        .split(';')
        .map(cookie => cookie.trim())
        .filter(cookie => cookie.startsWith(name + '='))
        .map(cookie => cookie.substring(name.length + 1))

    return cookieValue ? decodeURIComponent(cookieValue) : false
}
